const relativeTimeFormatter = new Intl.RelativeTimeFormat("pl", {
  numeric: "auto",
});

export const formatRelativeDate = (dateValue: string): string => {
  const date = new Date(dateValue);
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();
  const diffMinutes = Math.round(diffMs / (1000 * 60));
  const diffHours = Math.round(diffMs / (1000 * 60 * 60));
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.round(diffMs / (1000 * 60 * 60 * 24 * 7));
  const diffMonths = Math.round(diffMs / (1000 * 60 * 60 * 24 * 30));
  const diffYears = Math.round(diffMs / (1000 * 60 * 60 * 24 * 365));

  if (Math.abs(diffMinutes) < 1)
    return relativeTimeFormatter.format(-1, "minute");
  if (Math.abs(diffMinutes) < 60)
    return relativeTimeFormatter.format(diffMinutes, "minute");
  if (Math.abs(diffHours) < 24)
    return relativeTimeFormatter.format(diffHours, "hour");
  if (Math.abs(diffDays) < 7)
    return relativeTimeFormatter.format(diffDays, "day");
  if (Math.abs(diffWeeks) < 4)
    return relativeTimeFormatter.format(diffWeeks, "week");
  if (Math.abs(diffMonths) < 12)
    return relativeTimeFormatter.format(diffMonths, "month");
  return relativeTimeFormatter.format(diffYears, "year");
};
